"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackShowBookingTextLinks = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackShowBookingTextLinks = (showElement) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ShowTextLink,
            feature_category: enums_1.GA4FeatureCategory.DirectBooking,
            show_element: showElement,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackShowBookingTextLinks = trackShowBookingTextLinks;
//# sourceMappingURL=trackShowBookingTextLinks.js.map